import React, { Component } from "react";
import { connect } from "react-redux";
// import PropTypes from "prop-types";
import { addUrlProps, UrlQueryParamTypes } from "react-url-query";
import { commonActions, userActions, alertActions } from "../../../redux/actions/";
// import ContainerPage from "../../../components/common/ContainerPage";
import { Translate } from "../../../utils/lang/translate";
import { initGAPg } from "../../../utils/TrakEvent";
import { Row, Form, Col, Button } from "react-bootstrap";
import "../../../styles/Admin/AddAgent.scss";
import globalServices from "../../../services/global/global.services";
import { Doughnut } from "react-chartjs-2";

const urlPropsQueryConfig = {
  began: { type: UrlQueryParamTypes.string },
  end: { type: UrlQueryParamTypes.string },
  agent: { type: UrlQueryParamTypes.string },
};

class AddAgentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agent: {
        full_name: "",
        username: "",
        password: "",
        sex: "M",
        orders_limit: 50,
      },
      country: 1,
      errors: {},
      ForceProps: false,
      agentList: [],
      agentSearch: "",
    };

    this.handleFilterAgentList = this.handleFilterAgentList.bind(this);
    this.filterAgents = this.filterAgents.bind(this);
    this.forceProps = this.forceProps.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  static propTypes = {};
  componentDidMount() {
    document.title = "Maystro Confirmation - " + Translate("titles", "agents");
    initGAPg();
    this.props.ListAgents();

    globalServices
      .getAllAgents()
      .then((response) => {
        if (response?.data)
          this.setState({
            ...this.state,
            agentList: response?.data,
          });
      })
      .catch((error) => {});
  }
  componentWillReceiveProps(nextProps) {
    const { registerFlag } = nextProps;

    if (this.props.registerFlag === "0" && registerFlag === "2") {
      this.props.SendAlert("error", Translate("alert", "failedcreateagent"));
    }
    if (this.props.registerFlag === "0" && registerFlag === "1") {
      this.props.SendAlert("success", Translate("alert", "successcreateagent"));
      this.props.ListAgents();
    }
  }

  forceProps() {
    this.setState({
      ForceProps: true,
    });
  }

  handleChange(e) {
    const { agent } = this.state;
    this.setState({
      agent: {
        ...agent,
        [e.target.name]: e.target.value,
      },
    });
  }
  onChangeCountry(e) {
    this.setState({
      country: e?.target?.value,
    });
  }

  handleSelect(elem, name) {
    this.setState({
      [name]: elem,
    });
  }
  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    let user = {
      ...this.state.agent,
      country: this.state.country,
      orders_limit: Number(this.state.agent.orders_limit),
    };

    this.props.RegisterAgent(user);
  }

  handleFilterAgentList(event) {
    this.setState({
      ...this.state,
      agentSearch: event?.target?.value,
    });
  }
  filterAgents(agent) {
    if (this?.state?.agentSearch === "") return agent;
    else if (agent?.full_name?.toLowerCase().includes(this?.state?.agentSearch.toLowerCase()) || agent?.username?.toLowerCase().includes(this?.state?.agentSearch?.toLowerCase())) return agent;
    else return null;
  }
  render() {
    return (
      <div className="admin_addAgent">
        <h2>{Translate("titles", "agents")}</h2>
        <div className="admin_addAgent_addForm">
          <Row className="perfectC">
            <h4>{Translate("agents", "create")}</h4>
          </Row>
          <Row className="perfectC">
            <Col xs={12} sm={6}>
              <Form className="w-100" onSubmit={this.handleSubmit}>
                <Form.Group>
                  <Form.Label className="d-flex flxDrc">{Translate("agents", "full_name")}</Form.Label>
                  <Form.Control type="text" size="lg" required name="full_name" placeholder="Please enter the agent's name" value={this.state.agent.full_name} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="d-flex flxDrc">{Translate("agents", "username")}</Form.Label>
                  <Form.Control type="text" size="lg" required name="username" placeholder="Please enter the agent's username" value={this.state.agent.username} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="d-flex flxDrc">{Translate("auths", "password")}</Form.Label>
                  <Form.Control type="password" size="lg" required name="password" placeholder="Please enter the agent's password" value={this.state.agent.password} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="d-flex flxDrc">{Translate("auths", "regionsagent")}</Form.Label>
                  <select className="form-control form-control-lg" defaultValue={this.state.country} onChange={this.onChangeCountry}>
                    <option value={1}>{Translate("agents", "dzagent")}</option>
                    <option value={2}>{Translate("agents", "tnagent")}</option>
                  </select>
                </Form.Group>

                <Form.Group>
                  <Form.Label className="d-flex flxDrc">{Translate("agents", "gender")}</Form.Label>
                  <Form.Check type={"radio"} size="lg" required name="sex" label={`Male`} value={"M"} checked={this.state.agent.sex === "M"} onChange={this.handleChange} />
                  <Form.Check type={"radio"} size="lg" required name="sex" label={`Female`} value={"F"} checked={this.state.agent.sex === "F"} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="d-flex flxDrc">{Translate("agents", "orderslimit")}</Form.Label>
                  <Form.Control type="number" name="orders_limit" min={30} max={500} value={this.state.agent.orders_limit} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group as={Row} className="perfectC">
                  <Button type="submit" size="lg" className="btn btn-primary">
                    {Translate("agents", "create")}
                  </Button>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </div>

        <div className="admin_addAgent_agentListTable">
          <div className="admin_addAgent_agentListTable_top">
            <h2>{Translate("titles", "agentslist")}</h2>
            <input type="search" onChange={this?.handleFilterAgentList} placeholder="Rechercher..." />
          </div>

          <table>
            <thead>
              <tr>
                <th>{Translate("agents", "full_name")}</th>
                <th>{Translate("auths", "username")}</th>
                <th>{Translate("agents", "gender")}</th>
                <th>{Translate("agents", "orderslimit")}</th>
                <th>Statistics</th>
              </tr>
            </thead>
            <tbody>
              {this.state?.agentList.filter(this.filterAgents).map((agent, index) => {
                const toBeConfirmed = agent?.stats?.orders_2b_confirmed;
                const callBack = agent?.stats?.orders_callback;
                const cancelledToday = agent?.stats?.orders_cancelled_today;
                const confirmedToday = agent?.stats?.orders_confirmed_today;
                const pending = agent?.stats?.orders_pending;
                const postponedToday = agent?.stats?.orders_postponed_to_today;

                const daughnut_datasets = [
                  {
                    label: "Orders",
                    backgroundColor: [
                      "#fac710", //pending
                      "#1bb99a", // confirmed today
                      "#007bff", // callback
                      "#dc3545", // canceled today
                      "#a436ac", // postponed today
                    ],
                    data: [pending, confirmedToday, callBack, cancelledToday, postponedToday],
                  },
                ];
                const daughnut_labels = [
                  // "To be confirmed",
                  "Pending",
                  "Confirmed today",
                  "Callback",
                  "Cancelled today",
                  "Postponed to today",
                ];

                const daughnut_options = {
                  animation: {
                    animateScale: true,
                  },
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                };
                const daughnut_data = {
                  labels: daughnut_labels,
                  datasets: daughnut_datasets,
                };

                return (
                  <tr key={index}>
                    <td>{agent?.full_name}</td>
                    <td>{agent?.username}</td>
                    <td>{agent?.sex}</td>
                    <td>{agent?.orders_limit}</td>
                    <td className="agentListaTable_statsColumn">
                      <figure>
                        <Doughnut data={daughnut_data} height={"100"} width={"100"} options={daughnut_options} />

                        <figcaption>
                          To be confirmed : <mark>{toBeConfirmed}</mark>
                        </figcaption>
                      </figure>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
function mapState(state) {
  const { GettingAgents, AgentsList } = state.common;
  const { registerFlag, registerData } = state.user;

  return { GettingAgents, AgentsList, registerFlag, registerData };
}

const actionCreators = {
  ListAgents: commonActions.ListAgents,
  RegisterAgent: userActions.Register,
  SendAlert: alertActions.SendAlert,
};

const connectedAddAgentPage = connect(mapState, actionCreators)(AddAgentPage);
const QueryProps = addUrlProps({ urlPropsQueryConfig })(connectedAddAgentPage);
export { QueryProps as AddAgentPage };
